import { Spin } from 'antd';
import classNames from 'classnames';

import styles from './counterPureRederer.module.less';

const CounterPureContent = ({ loading, ref, data, widget }) => {
  const unit = widget?.queryParams?.unit;

  return (
    <Spin spinning={loading} size="large">
      <div ref={ref} className={styles.container}>
        <div className={styles.content}>
          <div className={styles.metricSection}>
            <div className={styles.valueBlock}>
              <span className={classNames(styles.primaryValue, data?.color)}>{data?.value}</span>
              {unit && <span className={styles.unitLabel}>{unit}</span>}
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export const renderCounterPureContent = props => <CounterPureContent {...props} />;
